import { Add } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, FormLabel, Grid, IconButton, Tooltip } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getFrecuenciasEstudio, getMetodologiasEmpleadas, getTiposEstudio } from "../../../../../../../redux/actions/resolucion";
import FormikActions from "../../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../../commons/formik/FormikAutocomplete";
import FormikTextField from "../../../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../../styled/Prevencion";
import { ValidateEstudiosAmbientales } from "../../formValidations";
import MetodologiaFormContainer from '../form/MetodologiaFormContainer';

const EstudioAmbientalesForm = ({
    values,
    open,
    handleClose,
    handleSubmit,
    handleOpenMetodologiaEmpleada,
    loading,
    valuesMetodologia,
    openFormMetodologia,
    handleCloseFormMetodologia,
    id,
}) => {
    const dispatch = useDispatch();
    const estudiosAgregadosLocalmente = useSelector((state) => state.resolucion.abmSustancia.estudios);
    const tiposEstudio = useSelector((state) => state.resolucion.tiposEstudio.data);
    const frecuenciasEstudio = useSelector((state) => state.resolucion.frecuenciasEstudio.data);
    const metodologiasEmpleadas = useSelector((state) => state.resolucion.metodologiasEmpleadas.data);

    const getMetodologias = (idTipoEstudio) => {
        dispatch(getMetodologiasEmpleadas(idTipoEstudio))
    }

    return (
        <Dialog open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Estudio Ambiental / Biológico</DialogTitle>
            {
                loading ? <CircularLoading /> : (
                    <Formik
                        initialValues={values}
                        onSubmit={(values) => handleSubmit(values)}
                        validationSchema={ValidateEstudiosAmbientales(estudiosAgregadosLocalmente, id)}
                    >
                        {({ values, setFieldValue }) => (

                            <Form>
                                <DialogContent>
                                    <StyledResolucion.DialogGridContainer container>
                                        <StyledResolucion.DialogGridItem item xs={12} >
                                            <FormikAutocomplete
                                                name="idTipoEstudio"
                                                label="Tipo de Estudio*"
                                                fullWidth
                                                options={tiposEstudio}
                                                renderOption={(option) => option.nombre}
                                                filterOptions={(option) => option.nombre}
                                                getOptions={() => (dispatch(getTiposEstudio()))}
                                                callBack={(v) => {
                                                    if (v !== null) {
                                                        getMetodologias(v.id)
                                                    }
                                                    setFieldValue("idMetodologiaEmpleada", null);
                                                }}
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        <StyledResolucion.DialogGridItem item xs={5} >
                                            <FormLabel>
                                                Frecuencia del Estudio*
                                            </FormLabel>
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={3}>
                                            <FormikTextField
                                                name="numeroFrecuencia"

                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item xs={4}>
                                            <FormikAutocomplete
                                                name="frecuenciaEstudio"
                                                fullWidth
                                                options={frecuenciasEstudio}
                                                renderOption={(option) => option.nombre}
                                                filterOptions={(option) => option.nombre}
                                                getOptions={() => (dispatch(getFrecuenciasEstudio()))}

                                            />
                                        </StyledResolucion.DialogGridItem>
                                        <StyledResolucion.DialogGridItem item container xs={12} >
                                            <Grid item xs={10}>
                                                <FormikAutocomplete
                                                    name="idMetodologiaEmpleada"
                                                    label="Metodología Empleada *"
                                                    fullWidth
                                                    disabled={!values.idTipoEstudio}
                                                    options={metodologiasEmpleadas}
                                                    renderOption={(option) => option.nombre}
                                                    filterOptions={(option) => option.nombre}
                                                    getOptions={() => (dispatch(getMetodologiasEmpleadas(values.idTipoEstudio)))}

                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Tooltip title="Agregar Metodología" >
                                                    <IconButton disabled={!values.idTipoEstudio} onClick={() => handleOpenMetodologiaEmpleada(values)}>
                                                        <Add />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </StyledResolucion.DialogGridItem>
                                        <MetodologiaFormContainer
                                            values={valuesMetodologia}
                                            open={openFormMetodologia}
                                            metodologiasEmpleadas={metodologiasEmpleadas}
                                            handleClose={handleCloseFormMetodologia}
                                            setFieldValue={setFieldValue}

                                        />
                                    </StyledResolucion.DialogGridContainer>
                                </DialogContent>

                                <DialogActions>
                                    <FormikActions handleCancel={handleClose} />
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                )
            }

        </Dialog>
    )
}

export default EstudioAmbientalesForm;